import { styled } from '@mui/material/styles';
import { ListItemText } from '@sunwisesoftware/sunwise-ui';

export default styled(ListItemText)(({ size }) => ({
    '& .MuiListItemText-primary': {
        color: '#FFFFFF',
        fontSize: size === 'small' ? '12px' : '14px',
        lineHeight: 'initial',
        marginLeft: '16px',
        textAlign: 'left',
    },
}));
